<template>
	<div class="fixed top-8 left-1/2 -translate-x-1/2 flex flex-col-reverse items-center z-50">
		<Toast
			v-for="(toast, index) in list"
			:key="index"
			:toast-id="toast.toastId"
			:index="toast.index"
			:message="toast.message"
			:description="toast.description"
			:type="toast.type"
			:dialog="toast.dialog"
			:on-confirm="toast.onConfirm"
			:on-cancel="toast.onCancel"
			:confirm-text="toast.confirmText"
			:cancel-text="toast.cancelText"
		/>
		<!-- <pre>{{list}}</pre> -->
	</div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { toastsList } from "~/ui-kit/utils/useToast";
import Toast from "./toast.vue";

export default defineComponent({
	name: "ToastContainer",
	components: { Toast },
	setup() {
		const list = computed(() => toastsList.value);

		return {
			list,
		};
	},
});
</script>
